import { ActionButton } from '@library/components/buttons';
import { PLAYER_PACKS_CHILD_PATHS } from '@bo-constants/routes';
import { PageHeader } from '@library/components/layout/PageHeader';
import { PlusCircleIcon } from '@heroicons/react/24/outline';
import { useNavigate } from 'react-router-dom';

export interface PlayerPacksHeaderProps {
  disableCreateResolution?: boolean;
}

export const PlayerPacksHeader = ({
  disableCreateResolution = false
}: PlayerPacksHeaderProps) => {
  const navigate = useNavigate();

  return (
    <PageHeader moduleName="Entities" title="Player Packs">
      <ActionButton
        dataTestId="create-new-resolution"
        disabled={disableCreateResolution}
        handleOnClick={() => navigate(PLAYER_PACKS_CHILD_PATHS.create)}
        title="Create new player pack"
      >
        <div className="flex items-center">
          <PlusCircleIcon className="text-soClean-100 mr-2 size-5" />
          <span>Create New Player Pack </span>
        </div>
      </ActionButton>
    </PageHeader>
  );
};
